var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsersSolid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(852 2154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.631,13.552A3.026,3.026,0,1,0,13.6,10.526,3.014,3.014,0,0,0,16.631,13.552Zm-8.07,0a3.026,3.026,0,1,0-3.026-3.026A3.014,3.014,0,0,0,8.561,13.552Zm0,2.017C6.211,15.57,1.5,16.75,1.5,19.1v2.522H15.622V19.1C15.622,16.75,10.911,15.57,8.561,15.57Zm8.07,0c-.293,0-.625.02-.978.05A4.257,4.257,0,0,1,17.64,19.1v2.522h6.052V19.1C23.692,16.75,18.981,15.57,16.631,15.57Z",
    transform: "translate(-849.5 -2153.5)",
    fill: "#494d7d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "translate(-852 -2154)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersSolid);
export default __webpack_public_path__ + "static/media/Users-Solid.e11bbee99fd1883d8ef2dc102f081b95.svg";
export { ForwardRef as ReactComponent };